export function debounce(func, wait) {
    let timeout;
    let cancelToken = { isCancel: false };
    
    const debounced = (...args) => {
      cancelToken.isCancel = true;
      cancelToken = { isCancel: false };
      
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (!cancelToken.isCancel) {
          func.apply(this, [...args, cancelToken]);
        }
      }, wait);
      
      return cancelToken;
    };
    
    debounced.cancel = () => {
      clearTimeout(timeout);
      cancelToken.isCancel = true;
    };
    
    return debounced;
  }